import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { CardTransactionLimit } from 'store/products/typings/cardLimits'
import { ReviewSubLabel } from 'dls'

interface OwnProps {
  labelKey: string
  cardLimit?: CardTransactionLimit
  currencySymbol: string
  noValueContent?: React.ReactNode
}

const CustomerCanManageSubValue = ({ labelKey, cardLimit, currencySymbol, noValueContent }: OwnProps) => {
  const { t } = useTranslation()

  if (!cardLimit) {
    return null
  }

  return (
    <ReviewSubLabel
      label={t(labelKey)}
      noValueContent={noValueContent}
      buttonComponentType={RouterLink}
      value={
        cardLimit?.enableSubscriptionOverride ? (
          <>
            {t('Yes:')} {currencySymbol}
            {new Intl.NumberFormat('en-GB').format(cardLimit.amount.minimum as any)} -{' '}
            {cardLimit.subscriptionOverrideMaximum ? currencySymbol : ''}
            {new Intl.NumberFormat('en-GB').format(cardLimit.subscriptionOverrideMaximum as any)}
          </>
        ) : null
      }
    />
  )
}

export default CustomerCanManageSubValue
